import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ContactPopup.module.css';
import { exists } from './utils';
import ProfileImage from './ProfileImage';

/**
 * ProfileBanner component that displays the talent's profile information
 * 
 * @param {Object} props - Component props
 * @param {Object} props.talent - Talent data object
 * @returns {JSX.Element} - Rendered component
 */
const ProfileBanner = ({ talent }) => {
    const { t } = useTranslation();
    
    if (!talent) return null;
    
    // Format the name with proper capitalization
    const formattedName = [
        exists(talent.first_name) ? talent.first_name : '',
        exists(talent.last_name) ? talent.last_name : ''
    ].filter(Boolean).join(' ');
    
    return (
        <div className={styles.profileBanner}>
            <div className={styles.profileBannerContent}>
                <ProfileImage 
                    profileImage={talent.profile_image}
                    hideProfilePicture={talent.hide_Profile_Picture}
                    firstName={talent.first_name}
                    lastName={talent.last_name}
                    uploadsPath={process.env.REACT_APP_UPLOADS_PATH || ''}
                />
                
                <div className={styles.profileInfo}>
                    {formattedName && (
                        <h3 className={styles.profileName}>
                            {formattedName}
                        </h3>
                    )}
                    
                    {exists(talent.working_title) && (
                        <p className={styles.profileTitle}>{talent.working_title}</p>
                    )}
                    
                    {/* Quick stats row */}
                    <div className={styles.quickStatsRow}>
                        {exists(talent.country) && (
                            <span className={styles.quickStat}>
                                <span className={styles.quickStatIcon}>📍</span>
                                {t('general.country.' + talent.country)}
                            </span>
                        )}
                        {exists(talent.years_of_experience) && talent.years_of_experience > 0 && (
                            <span className={styles.quickStat}>
                                <span className={styles.quickStatIcon}>💼</span>
                                {talent.years_of_experience} {talent.years_of_experience === 1 ? 
                                    t('general.UI.year') : t('general.UI.years')}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileBanner; 